import { useApi, SKY_API_ENDPOINT } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { DisplaySwitch, Flex } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';

export default function HistoricTabs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');

  const [response, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: '/backstop/historic/',
    queryParams: {
      days_ago: chartDaysAgo
    }
  });
  const data = response?.data;

  if (error) {
    throw error;
  }
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );
  const [activeDisplayOption, setActiveDisplayOption] = useState(
    'aggregate_backstop_capital'
  );
  const displayOptions = useMemo(
    () => [
      {
        key: 'aggregate_backstop_capital',
        value: 'Aggregate Backstop Capital'
      },
      { key: 'sky_backstop_capital', value: 'Allocated Genesis Capital' }
    ],
    []
  );

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <HistoricGraphs
          data={data}
          timeFilter={timeFilter}
          activeDisplayOption={activeDisplayOption}
          chartDaysAgo={chartDaysAgo}
          displayOptions={displayOptions}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
